'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartTopBar = PushCartTopBar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var animationIcon = window.theme.cart.animationIcon;
var animationIconColor = window.theme.cart.animationIconColor;

function PushCartTopBar(_ref) {
  var title = _ref.title;

  return _react2.default.createElement('div', { className: 'psh-TopBar' }, _react2.default.createElement('div', { className: 'psh-TopBar_Inner' }, _react2.default.createElement('div', { className: 'psh-TopBar_Body' }, _react2.default.createElement('h4', { className: 'psh-TopBar_Title' }, title), animationIcon && _react2.default.createElement('div', { className: 'psh-Topbar_Animation' }, _react2.default.createElement('span', {
    className: 'psh-Topbar_Icon psh-Topbar_Icon-one ' + animationIcon,
    style: { color: animationIconColor }
  }), _react2.default.createElement('span', {
    className: 'psh-Topbar_Icon psh-Topbar_Icon-two ' + animationIcon,
    style: { color: animationIconColor }
  }), _react2.default.createElement('span', {
    className: 'psh-Topbar_Icon psh-Topbar_Icon-three ' + animationIcon,
    style: { color: animationIconColor }
  })), _react2.default.createElement('button', { className: 'psh-TopBar_Close', 'data-module-drawers-close': 'cart' }, _react2.default.createElement('span', { className: 'am-icon-close-thin' })))));
}

PushCartTopBar.propTypes = {
  title: _propTypes2.default.string.isRequired
};